/**
 * Tiempo declarado (segundos) -> texto legible.
 *
 * Petición del PO (pasada 27): `943` no se enseña en crudo, es una duración.
 *
 * ⚠ Se buscó primero un helper reutilizable y **NO existe** en el proyecto: `useDateFormatter` solo
 * sabe de fechas y horas, y el formateo de duraciones está duplicado a mano en al menos cuatro
 * ficheros con dos convenciones distintas ("Xh YYm / Ym YYs / Ys" en Planner y monitoring, y
 * "HH:MM:SS" en ProcessTraceability, DateTimeFunctions y CellPartsTable). Así que esto NO inventa un
 * formato nuevo: adopta literalmente el idioma que el producto ya usa dos veces
 * (`planner/PlannerProgressDisplay.jsx:18-27`, copiado a su vez en
 * `monitoring/byGroupVisuals.js:122-131`, cuyo propio comentario admite la copia).
 *
 * Extraer un helper compartido y unificar las cuatro copias es una decisión del hub: tocaría
 * ficheros de otros módulos, fuera del alcance de esta historia.
 *
 * @param {number|string|null|undefined} totalSeconds Segundos declarados, tal cual los sirve N4.
 * @returns {string} '' cuando no hay dato, para que quien llama decida qué decir en su lugar.
 */
// ADDENDUM 13 (E19): se llamaba `formatDeclaredTime` cuando solo había un tiempo que mostrar. Ahora
// hay TRES duraciones y una más en la preparación, y ninguna es "declarada": este formateador no
// sabe de cuál viene, solo convierte segundos en un tiempo legible.
export const formatDuration = (totalSeconds) => {
  if (totalSeconds === null || totalSeconds === undefined || totalSeconds === '') return ''
  const numeric = Number(totalSeconds)
  if (Number.isNaN(numeric)) return ''
  const safeSeconds = Math.max(0, Math.round(numeric))
  const hours = Math.floor(safeSeconds / 3600)
  const minutes = Math.floor((safeSeconds % 3600) / 60)
  const seconds = safeSeconds % 60
  if (hours > 0) return `${hours}h ${String(minutes).padStart(2, '0')}m`
  if (minutes > 0) return `${minutes}m ${String(seconds).padStart(2, '0')}s`
  return `${seconds}s`
}
